<script setup>
import {ref, watch} from "vue";
import CloseIcon from "@/Svgs/CloseIcon.svg.vue"
import {trans} from "laravel-vue-i18n";

const props = defineProps({
    canClose: {
        type: Boolean,
        default: false
    },
    hasActions: {
        type: Boolean,
        default: true
    }
})

const dialog = ref(null);
const open = defineModel('open', {default: false});
const emit = defineEmits(['confirm']);

const handleClose = () => {
    open.value = false;
}

watch(open, (isOpen, oldValue)=>{
    if(isOpen){
        dialog.value.showModal();
        dialog.value.addEventListener('close', handleClose);
    }else{
        dialog.value.close();
        dialog.value.removeEventListener('close', handleClose);
    }
})
</script>

<template>
    <dialog ref="dialog" class="defaultDialog dialog">
        <div class="dialog-title">
            <h2>
                <slot name="title"></slot>
            </h2>
            <slot name="header-right"></slot>
            <button
                class="dialog-title-close -is-clickable"
                v-if="canClose"
                @click.prevent="open = false"
            >
                <CloseIcon />
            </button>
        </div>
        <div class="dialog-body">
            <slot name="body"></slot>
        </div>
        <div
            v-if="hasActions"
            class="dialog-actions"
        >
            <slot name="actions">
                <button
                    class="button -is-primary --isBlue --isFullWidthDesktop"
                    @click.prevent="open = false"
                    v-text="trans('auth.login.accept-condition')"
                />
            </slot>
        </div>
    </dialog>
</template>

<style lang="scss" scoped>
@use 'include-media/dist/include-media' as *;
@use '~@/base/variables' as *;
@use '~@/base/mixins' as *;

.dialog{
    @include container(700px);
    position: fixed;
    z-index: 5;
    inset: 0 0 0 0;
    display: none;
    border: none;
    border-radius: 8px;
    outline: none;
    cursor: initial;
    overflow: auto;
    padding: 25px;
    filter: drop-shadow(0 10px 25px rgba(black, 0.1));

    @include media($breakpoint-phone) {
        width: 90%;
    }
    &::-webkit-scrollbar-track {
        background-color: white;
    }
    &::-webkit-scrollbar {
        width: 5px;
        background-color: white;
    }
    &::-webkit-scrollbar-thumb {
        background-color: $gray500;
    }

    &[open]{
        display: block;

        &::backdrop{
            position: fixed;
            inset: 0;
            background: rgba(black, 0.15);
            backdrop-filter: blur(2px);
        }
    }
    &-header{
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 10px;
    }
    &-title{
        position: relative;
        margin-bottom: 0;
        flex-grow: 1;

        &-close {
            position: absolute;
            background: transparent;
            border: none;
            top: 0;
            right: 0;
            padding: 0;
        }
    }
    &-body {
    }
    &-actions {
        display: flex;
        justify-content: flex-end;
        margin-top: 20px;

        @include media($breakpoint-phone) {
            flex-direction: column;
        }
    }
}

</style>
